import React, { useReducer } from 'react';
import logo1 from './Images/logo1.png';
import logo2 from './Images/logo2.png';
import logo3 from './Images/logo3.png';
import logo4 from './Images/logo4.png';
import logo5 from './Images/logo5.png';
import logo6 from './Images/logo6.png';
import logo7 from './Images/logo7.png';
import logo8 from './Images/logo8.png';


const slides = [
  {
    title: "",
    subtitle: "",
    description: "",
    image:`${logo1}`
  },
  {
    title: "",
    subtitle: "",
    description:"" ,
    image:`${logo2}`
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:`${logo3}`
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
    `${logo4}`
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
    `${logo5}`  
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
    `${logo6}`  
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
    `${logo7}`  
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
    `${logo8}`  
  }
 
];

function useTilt(active) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (!ref.current || !active) {
      return;
    }

    const state = {
      rect: undefined,
      mouseX: undefined,
      mouseY: undefined
    };

    let el = ref.current;

    const handleMouseMove = (e) => {
      if (!el) {
        return;
      }
      if (!state.rect) {
        state.rect = el.getBoundingClientRect();
      }
      state.mouseX = e.clientX;
      state.mouseY = e.clientY;
      const px = (state.mouseX - state.rect.left) / state.rect.width;
      const py = (state.mouseY - state.rect.top) / state.rect.height;

      el.style.setProperty("--px", px);
      el.style.setProperty("--py", py);
    };

    el.addEventListener("mousemove", handleMouseMove);

    return () => {
      el.removeEventListener("mousemove", handleMouseMove);
    };
  }, [active]);

  return ref;
}

const initialState = {
  slideIndex: 0
};

const slidesReducer = (state, event) => {
  if (event.type === "NEXT") {
    return {
      ...state,
      slideIndex: (state.slideIndex + 1) % slides.length
    };
  }
  if (event.type === "PREV") {
    return {
      ...state,
      slideIndex:
        state.slideIndex === 0 ? slides.length - 1 : state.slideIndex - 1
    };
  }
};

function Slide({ slide, offset }) {
  const active = offset === 0 ? true : null;
  const ref = useTilt(active);

  return (
    <div
      ref={ref}
      className="slide"
      data-active={active}
      style={{
        "--offset": offset,
        "--dir": offset === 0 ? 0 : offset > 0 ? 1 : -1
      }}
    >
      <div
        className="slideBackground"
        style={{
          backgroundImage: `url('${slide.image}')`
        }}
      />
      <div
        className="slideContent"
        style={{
          backgroundImage: `url('${slide.image}')`
        }}
      >
        <div className="slideContentInner">
          <h2 className="slideTitle">{slide.title}</h2>
          <h3 className="slideSubtitle">{slide.subtitle}</h3>
          <p className="slideDescription">{slide.description}</p>
        </div>
      </div>
    </div>
  );
}

export default function LogoDesign() {
  const [state, dispatch] = React.useReducer(slidesReducer, initialState);

  return (
    <>
    <div className='' style={{background:'transparent'}} >
    <div className="slides" style={{overflow:'hidden', background:'transparent'}}>
      <button className='slide-btn' onClick={() => dispatch({ type: "PREV" })} >‹</button>

      {[...slides, ...slides, ...slides].map((slide, i) => {
        let offset = slides.length + (state.slideIndex - i);
        return <Slide slide={slide} offset={offset} key={i} />;
      })}
      <button className='slide-btn ' onClick={() => dispatch({ type: "NEXT" })} >›</button>
    </div>
    </div>
       </>
  );
}

